import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl-next';
import { MountEvent } from '@atlassian/analytics-bridge';
import Image from '@atlaskit/image';
import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/new';
import messages from '../project-pages-improvement/messages';
import { PreviewWrapper, TopBar, TopBarDot, Content, BottomBar, PreviewTeaser } from './styled';
import { type TemplatePreviewViewProps } from './types';
import { useTemplate } from '../../containers/template';
import { TemplateType } from '../../containers/template/types';
import TermsAndPrivacyPolicy from './terms-and-privacy';
import { type WithIntlProps } from '../../common/types';

const TemplatePreviewView = ({
	intl,
	shouldDisplayTermsAndConditions = false,
	primaryAction,
	secondaryAction,
	onViewed,
}: WithIntlProps<TemplatePreviewViewProps>) => {
	const { template } = useTemplate();
	// eslint-disable-next-line no-undef
	const shouldDisplayPreview = !__SERVER__ && template && template.type === TemplateType.Confluence;
	return (
		<>
			<PreviewWrapper>
				<TopBar>
					<TopBarDot />
					<TopBarDot />
					<TopBarDot />
				</TopBar>
				<Content shouldDisplayTermsAndConditions={shouldDisplayTermsAndConditions}>
					{shouldDisplayPreview ? (
						<Image
							src={template.preview.preExpand.default}
							srcDark={template.preview.preExpand.dark}
							width="100%"
							alt={`${template.name.description} Confluence Template`}
						/>
					) : null}
				</Content>
				<BottomBar>
					<PreviewTeaser>{intl.formatMessage(messages.previewTeaser)}</PreviewTeaser>
					<ButtonGroup>
						<Button
							appearance="subtle"
							onClick={secondaryAction.onClick}
							isLoading={secondaryAction.isLoading}
						>
							<FormattedMessage {...secondaryAction.text} />
						</Button>
						<Button
							appearance="primary"
							onClick={primaryAction.onClick}
							isLoading={primaryAction.isLoading}
						>
							{!primaryAction.isLoading && (
								<MountEvent onMount={primaryAction.onReady || (() => void 0)} />
							)}
							<FormattedMessage {...primaryAction.text} />
						</Button>
						<MountEvent onMount={onViewed} />
					</ButtonGroup>
				</BottomBar>
			</PreviewWrapper>
			{shouldDisplayTermsAndConditions && <TermsAndPrivacyPolicy />}
		</>
	);
};

export default injectIntl(TemplatePreviewView);
